import { ApiCachedRequestResponse } from './api-cached-request-response';
import { Observable } from 'rxjs';
import { CachedValue } from './cached-value';

export class ApiServiceCacheItem<T> {
	observable?: Observable<T>;
	cachedValue?: CachedValue<T>;
	cachedResponse?: ApiCachedRequestResponse<T>;

	constructor(public url: string) {
	}

	get value(): T | undefined { return this.cachedValue === undefined ? undefined : this.cachedValue.value; }
	set value(val: T | undefined) { this.cachedValue = new CachedValue<T>(val); }
}
